import PaladinIcon from "src/assets/img/logos/paladin-icon.ico";
import RezyIcon from "src/assets/img/logos/rezy_icon.ico";
import BlikIcon from "src/assets/img/logos/blik-icon.ico";

import logoPaladin from "src/assets/img/logos/paladin.png";
import logoAdminkey from "src/assets/img/logos/admin_key.png";
import logoBlik from "src/assets/img/logos/LogoBlik.png";
import logoCupro from "src/assets/img/logos/cuprovyg.png";
import logo593 from "src/assets/img/logos/593_logo.png";
import logoBeAccess from "src/assets/img/logos/beaccess.png";
import logoRezy from "src/assets/img/logos/rezy.png";
import logoEps from "src/assets/img/logos/EPS_1.png";

const DOMAINS = {
  paladin: {
    title: "PALADIN",
    icon: PaladinIcon,
    logo: logoPaladin,
    hostname: ["qr.paladin.com.ec"],
  },
  adminkey: {
    title: "ADMIN KEY",
    icon: "",
    logo: logoAdminkey,
    hostname: ["adminkey.app", "adminkey.ai"],
  },
  blik: {
    title: "BLIK",
    icon: BlikIcon,
    logo: logoBlik,
    hostname: ["blik-ai.cloud", "www.blik-ai.cloud"],
  },
  eps: {
    title: "EPS",
    icon: "",
    logo: logoEps,
    hostname: ["eps.micasitaapp.com"],
  },
  beaccess: {
    title: "BE ACCESS",
    icon: "",
    logo: logoBeAccess,
    hostname: ["www.beaccess.net", "beaccess.net"],
  },
  rezy: {
    title: "REZY",
    icon: RezyIcon,
    logo: logoRezy,
    hostname: ["rezy.micasitaapp.com"],
  },
  security593: {
    title: "593 Security",
    icon: "",
    logo: logo593,
    hostname: ["app593security.micasitaapp.com"],
  },
  cupro: {
    title: "CUPROVYG",
    icon: "",
    logo: logoCupro,
    hostname: ["app.cuprovyg.com"],
  },
  micasita: {
    title: "Mi Casita",
    icon: "/favicon.ico",
    logo: "/assets/img/mi2.png",
  },
};

const getCustomConfig = (hostname) => {
  switch (hostname) {
    case "qr.paladin.com.ec":
      return DOMAINS.paladin;

    case "adminkey.app":
    case "adminkey.ai":
      return DOMAINS.adminkey;

    case "blik-ai.cloud":
    case "www.blik-ai.cloud":
      return DOMAINS.blik;

    case "eps.micasitaapp.com":
      return DOMAINS.eps;

    case "beaccess.net":
    case "www.beaccess.net":
      return DOMAINS.beaccess;

    case "rezy.micasitaapp.com":
      return DOMAINS.rezy;

    case "app593security.micasitaapp.com":
      return DOMAINS.security593;

    case "app.cuprovyg.com":
      return DOMAINS.cupro;

    default:
      return DOMAINS.micasita;
  }
};

export default getCustomConfig;
